<template>
	<div>
		<slot name="status_lunas"></slot>
		<div class="p-x-16 p-y-20 bg-white card-tagihan">
			<slot name="header"></slot>
			<slot name="layanan"></slot>
			<slot name="biaya-tambahan"></slot>
			<slot name="total-tagihan"></slot>
			<slot name="pembayaran"></slot>
			<slot name="total-pembayaran"></slot>
			<slot name="benefit-non-discount"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTagihan",
}
</script>

<style scoped>
.bg-tagihan {
	background: linear-gradient(180deg, rgba(242, 245, 247, 0) 0%, #F2F5F7 100%);
}

.card-tagihan {
	border: 1px solid #C8D0DD;
	box-shadow: 0 4px 12px rgba(0, 34, 119, 0.06);
	border-radius: 10px;
}
</style>